import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ChecklistState, SetImeiBiped, SetSelectedTrade, SetSelectedTrades, ClearChecklist } from '@app/store/checklist/checklist.state';
import { IRelapseTradeResult } from './relapse.service';

@Injectable({
  providedIn: 'root',
})
export class RelapseStateService {
  constructor(private _store: Store) {}

  setSelectedTrade(trade: IRelapseTradeResult | null): void {
    this._store.dispatch(new SetSelectedTrade(trade));
  }

  getSelectedTrade(): IRelapseTradeResult | null {
    return this._store.selectSnapshot(ChecklistState.getSelectedTrade);
  }

  getSelectedTradeId(): string {
    return this.getSelectedTrade()?.tradeId ?? '';
  }

  setSelectedTrades(trades: any[]): void {
    this._store.dispatch(new SetSelectedTrades(trades));
  }

  getSelectedTrades(): any[] {
    return this._store.selectSnapshot(ChecklistState.getSelectedTrades) || [];
  }

  setImeiBiped(imei: string): void {
    this._store.dispatch(new SetImeiBiped(imei));
  }

  getImeiBiped(): string {
    return this._store.selectSnapshot(ChecklistState.getImeiBiped) || '';
  }

  clear(): void {
    this._store.dispatch(new ClearChecklist());
  }
}
